import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage"
import 'firebase/analytics'


export const firebaseConfig = {
  apiKey: "AIzaSyAfuNJuXpCHGQ0lrvq0RIPk8Lw4Nwcr2b8",
  authDomain: "bestel-3635d.firebaseapp.com",
  databaseURL: "https://bestel-3635d.firebaseio.com",
  projectId: "bestel-3635d",
  storageBucket: "bestel-3635d.appspot.com",
  messagingSenderId: "534522226239",
  appId: "1:534522226239:web:746e04c8f8198250adba8a",
  measurementId: "G-CY30DVFG9R"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
  firebase.analytics();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
export const firebaseAuth = firebase.auth()
export const firebaseStorage = firebase.storage();
export const firestoreDB = firebase.firestore()

